import React from 'react';
import i18n from 'i18n';
import HelpTooltip from 'components/overlays/helpTooltip/HelpTooltip';
import clsx from 'clsx';

export const ParameterOptions = () => {
  return (
    <p className="mb-0">
      <span>{i18n.t('transactions:editor.blazeDataParams')}</span>
      <span
        id="parameterOptionsHelp"
        className={clsx('ml-3', 'questionInTableHeader', 'position-relative')}
        style={{ top: 2 }}
        title={i18n.t('common:showHelp')}
      >
        <HelpTooltip id={'parameterOptionsHelpId'} />
      </span>
      <i
        style={{ fontStyle: 'initial' }}
        className={'js-parameterOptionsHelpId btn-link ml-2'}
        title={i18n.t('transactions:editor.parameterOptions')}
      >
        {i18n.t('transactions:editor.parameterOptions')}
      </i>
    </p>
  );
};

export default ParameterOptions;
